import {DiamondSector, type Project} from '../types/project';

export const diamondMinValue = 0.25;
export const diamondMaxValue = 4;

export const diamondTriangles = [
  {
    getPath: ({
      [DiamondSector.WEB]: web,
      [DiamondSector.LOCATION]: location
    }: NonNullable<Project['diamond']>) => {
      const webValue = Math.min(
        diamondMaxValue,
        Math.max(diamondMinValue, web)
      );
      const locationValue = Math.min(
        diamondMaxValue,
        Math.max(diamondMinValue, location)
      );

      return `M4 4L4 ${diamondMaxValue - webValue}L${
        diamondMaxValue + locationValue
      } 4Z`;
    },
    color: '#ff6e78'
  },
  {
    getPath: ({
      [DiamondSector.LOCATION]: location,
      [DiamondSector.CLOUD]: cloud
    }: NonNullable<Project['diamond']>) => {
      const locationValue = Math.min(
        diamondMaxValue,
        Math.max(diamondMinValue, location)
      );
      const cloudValue = Math.min(
        diamondMaxValue,
        Math.max(diamondMinValue, cloud)
      );

      return `M4 4L${diamondMaxValue + locationValue} 4L4 ${
        diamondMaxValue + cloudValue
      }Z`;
    },
    color: '#7832F5'
  },
  {
    getPath: ({
      [DiamondSector.CLOUD]: cloud,
      [DiamondSector.DATA]: data
    }: NonNullable<Project['diamond']>) => {
      const cloudValue = Math.min(
        diamondMaxValue,
        Math.max(diamondMinValue, cloud)
      );
      const dataValue = Math.min(
        diamondMaxValue,
        Math.max(diamondMinValue, data)
      );

      return `M4 4L4 ${diamondMaxValue + cloudValue}L${
        diamondMaxValue - dataValue
      } 4Z`;
    },
    color: '#5a78fa'
  },
  {
    getPath: ({
      [DiamondSector.DATA]: data,
      [DiamondSector.WEB]: web
    }: NonNullable<Project['diamond']>) => {
      const dataValue = Math.min(
        diamondMaxValue,
        Math.max(diamondMinValue, data)
      );
      const webValue = Math.min(
        diamondMaxValue,
        Math.max(diamondMinValue, web)
      );

      return `M4 4L${diamondMaxValue - dataValue} 4L4 ${
        diamondMaxValue - webValue
      }Z`;
    },
    color: '#fac34b'
  }
];
